export enum AlgoliaIndexPlaceholders {
  Language = '{language}',
  SiteName = '{site}',
}
